import { request } from '../../request';

const cartSlice3Request = request({
    type: 'cartSlice3Data',
    url: `slice3_config/ajax/cart`,
    notApi: true,
});

export default cartSlice3Request;
